import axiosIns from "@/api/axios";

export const GET_LIST = (params) => {
  return axiosIns.get("/location");
};

export const DETAIL = (id) => {
  return axiosIns.get(`/location/${id}/detail`);
};

export const CREATE = (payload) => {
  return axiosIns.post("/location/create", payload);
};

export const UPDATE = (id, payload) => {
  return axiosIns.put(`/location/${id}/update`, payload);
};

export const DELETE = (id) => {
  return axiosIns.delete(`/location/${id}/delete`);
};

export const GET_POINTING_USERS = (params) => {
  return axiosIns.get(`/log/user-pointing?${params}`);
};

export const GET_STATUS_USER = (params) => {
  return axiosIns.get(`/log/user-status?${params}`);
};

export const GET_LIST_GROUP = (params) => {
  return axiosIns.get(`/location/group/list?${params}`);
};
